import { ROOT_URL } from '../../config/root';

// export const ROOT_URL = ROOT_URL;
export const BASE_URL = `${ROOT_URL}/api`;



// WEBPACK FOOTER //
// ./src/api/root_url.js